<style>.injectedHartObject{
	display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}
.injectedHartObject:hover {
	background-color: #f4f5f5;
}</style>
<template><span></span></template>
<script>export default {
    data: {
    	objectInjected: false
    },
    created() {
    	window.addEventListener(
          "kundo-knowledge:script-loaded",
          (e) => {
            if (!this.objectInjected) {
                e.stopPropagation();
    			e.preventDefault();
                let kundoRoot = document.getElementById('kundo-knowledge-embed').shadowRoot;
                let styleObject = document.createElement('style');
                kundoRoot.prepend(styleObject);
                styleObject.innerHTML = '.injectedHartObject {display: flex;flex-direction: column;gap: 10px;width: 100%;height: 100%;justify-content: center;align-items: center;} .injectedHartObject:hover {background-color: #f4f5f5;cursor: pointer;color: #000000;} .injectedHartLogo {background-image: url("https://d1m1wyx9mob792.cloudfront.net/motionstudios.zoezi.se/files/a633ccba-a9c7-4397-9b82-9de5fbcd9750_300");background-size: contain;background-position: center;background-repeat: no-repeat;width: 50%;height: 50%;}';
                let itemWrapper = kundoRoot.querySelector('.category-list--startpage');
                let itemContainer = document.createElement('div');
                itemContainer.className = 'category-list-item-wrapper category-list-item-wrapper--startpage';
                itemWrapper.prepend(itemContainer);
                itemContainer.addEventListener("click", () => {
                    window.open('https://boka.motionstudios.se/studios/hart54/kundservice', '_self');
                });
                itemContainer.setAttribute('class', 'category-list-item-wrapper category-list-item-wrapper--startpage injectedHartObject');
                let logoObject = document.createElement('div');
                logoObject.setAttribute('class', 'injectedHartLogo');
                itemContainer.appendChild(logoObject);
                let logoText = document.createElement('span');
                itemContainer.appendChild(logoText);
                logoText.setAttribute('class', 'category-list-item__category-name');
                logoText.innerHTML = 'Jag har frågor kring Hart54';
                this.objectInjected = true;
            }
          },
          false,
        );
    }
}</script>